import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
  Box,
  Button,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Layout from "../components/Layout";

// #77 - My Requests: the agent's own submissions (carrier requests and add
// state requests), read-only, newest first.
const dateOf = (v) => (v ? new Date(v).toLocaleDateString("en-US") : "");
const title = (s) =>
  (s || "").replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

const Section = ({ heading, columns, rows, empty }) => (
  <Box sx={{ mb: 4 }}>
    <Typography variant="h6" sx={{ mb: 1 }}>
      {heading}
    </Typography>
    {rows.length === 0 ? (
      <Typography variant="body2" color="textSecondary">
        {empty}
      </Typography>
    ) : (
      <TableContainer component={Paper} variant="outlined">
        <Table size="small">
          <TableHead>
            <TableRow>
              {columns.map((c) => (
                <TableCell key={c}>{c}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((r) => (
              <TableRow key={r.key}>
                {r.cells.map((cell, i) => (
                  <TableCell key={i}>{cell}</TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    )}
  </Box>
);

const MyRequests = () => {
  const navigate = useNavigate();
  const [data, setData] = useState(null);

  useEffect(() => {
    let active = true;
    Promise.all([
      axios.get("/api/contract-request/mine").then((r) => r.data),
      axios.get("/api/add-state-request/mine").then((r) => r.data),
    ])
      .then(([contracts, addStates]) => {
        if (active) setData({ contracts, addStates });
      })
      .catch(() => {
        if (active) setData({ contracts: [], addStates: [] });
      });
    return () => {
      active = false;
    };
  }, []);

  return (
    <Layout>
      <Box sx={{ padding: 4, maxWidth: 900, margin: "0 auto" }}>
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate("/")}
          sx={{ mb: 1 }}
        >
          Back to dashboard
        </Button>
        <Typography variant="h5" sx={{ mb: 0.5 }}>
          My Requests
        </Typography>
        <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
          Everything you've submitted, newest first.
        </Typography>
        {!data ? (
          <Box sx={{ display: "flex", justifyContent: "center", padding: 6 }}>
            <CircularProgress />
          </Box>
        ) : (
          <>
            <Section
              heading="Carrier Requests"
              columns={["Submitted", "Carriers", "Type", "Status"]}
              empty="No carrier requests yet."
              rows={data.contracts.map((r) => ({
                key: r.id,
                cells: [
                  dateOf(r.createdAt),
                  (r.carriers || []).join(", "),
                  title(r.requestType),
                  title(r.status),
                ],
              }))}
            />
            <Section
              heading="Add State Requests"
              columns={["Submitted", "States", "Carriers", "Status"]}
              empty="No add state requests yet."
              rows={data.addStates.map((r) => ({
                key: r.id,
                cells: [
                  dateOf(r.createdAt),
                  (r.states || []).join(", "),
                  (r.carriers || []).join(", "),
                  title(r.status),
                ],
              }))}
            />
          </>
        )}
      </Box>
    </Layout>
  );
};

export default MyRequests;
